"use strict";
var ApiAddress = (function () {
    function ApiAddress() {
    }
    return ApiAddress;
}());
exports.ApiAddress = ApiAddress;
//# sourceMappingURL=D:/a/1/s/base/src/models/api-address.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/base/src/models/api-address.model.js